import { Button, Grid, Input, MenuItem, Select, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { TabNativeContent } from '../common/Tab';
import Insights from './Insights';
import service from '../../apis/service';
import { showProgress } from '../../redux/actions/DealershipActions';
import { ErrorToast, formatDate, notifySuccess } from '../utils/Utils';
import { CustomDatePopup } from './CustomDatePopup';
import ConfirmationDialog from '../common/ConfirmationDialog';
import { apiEndpoints } from '../../constants/apiEndpoints';

const useStyles = makeStyles(() => ({
  insights: {
    height: '95%',
    width: '60%',
    background: '#f3f5f6',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  topContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  actions: {
    display: 'flex',
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '5px',
  },
  latestVersion: {
    width: '100%',
    height: '20px',
    fontSize: '14px',
    color: '#667085',
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));
export default function InsightScreen({
  PERIOD_ARR,
  INSIGHT_TABS,
  selctedDealerId,
  timePeriod,
  setTimePeriod,
  setAppliedFilters,
  appliedFilters,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [insightData, setInsightData] = useState([]);
  const [insightTabId, setInsightTabId] = useState(0);
  const [isOpenCalendar, setIsOpenCalendar] = useState(false);
  const [selectedTimeRange, setSelectedTimeRange] = useState({});
  const [disableHash, setDisableHash] = useState(null);
  const [isOpenDisablePop, setIsOpenDisablePop] = useState(false);

  useEffect(() => {
    if (appliedFilters.range) {
      setSelectedTimeRange({
        startDate: formatDate(appliedFilters.range.startDate),
        endDate: formatDate(appliedFilters.range.endDate),
      });
    }
  }, []);

  const fetchInsightsData = async (id) => {
    dispatch(showProgress(true));
    try {
      const response = await service.post(apiEndpoints.PX_INSIGHTS.replace('ID', id), {
        filters: {
          time: {
            ...selectedTimeRange,
            type: timePeriod + 1,
          },
          type: InsightTabTypes[insightTabId],
        },
      });
      setInsightData(response);
      dispatch(showProgress(false));
    } catch (err) {
      ErrorToast(err);
      dispatch(showProgress(false));
    }
  };

  const handleInsightTabId = (id) => {
    setInsightTabId(id);
  };

  useEffect(() => {
    if (selctedDealerId) {
      if (timePeriod !== 4) {
        fetchInsightsData(selctedDealerId);
      } else if (timePeriod === 4 && selectedTimeRange.endDate && selectedTimeRange.startDate) {
        fetchInsightsData(selctedDealerId);
      }
    }
  }, [selctedDealerId, insightTabId, timePeriod, selectedTimeRange]);

  const InsightTabTypes = ['ZERO_ACTIVITY', 'LEARNING_ACTIVITY', 'APP_CONFIG', 'REWARDS', 'LEADERBOARD'];

  const handleTimeRange = (val) => {
    setTimePeriod(val);
    if (val === 4) {
      setIsOpenCalendar(true);
    }
    setSelectedTimeRange({});
  };

  const handleRangeSelection = (range) => {
    setSelectedTimeRange({
      startDate: moment(range.startDate).format('YYYY-MM-DD'),
      endDate: moment(range.endDate).format('YYYY-MM-DD'),
    });
  };

  const handleEmailUsageReport = async () => {
    dispatch(showProgress(true));
    const filters = JSON.stringify({
      filters: {
        dealerships: [selctedDealerId],
        trendRequired: false,
        time: {
          ...selectedTimeRange,
          type: timePeriod + 1,
        },
      },
    });
    try {
      await service.post(apiEndpoints.PX_EMAIL, filters);
      notifySuccess('Usage Report Email Sent Successfully');
      dispatch(showProgress(false));
    } catch (err) {
      ErrorToast(err);
      dispatch(showProgress(false));
    }
  };

  const openConfirmationPop = (data) => {
    setIsOpenDisablePop(true);
    setDisableHash(data.hash);
  };

  const handleDisable = async () => {
    const enableData = new FormData();
    enableData.append('enable', 0);
    try {
      await service.put(apiEndpoints.PX_EMP_DISABLE.replace('HASH', disableHash), enableData);
      notifySuccess('Saved Successfully');
      fetchInsightsData(selctedDealerId);
    } catch (error) {
      ErrorToast(error);
    }
    setIsOpenDisablePop(false);
  };

  return (
    <Grid className={classes.insights}>
      <Grid className={classes.topContent}>
        <Typography variant="body1">Insights</Typography>
        <Grid className={classes.actions}>
          <Button style={{ width: '180px', marginRight: '10px' }} onClick={handleEmailUsageReport}>
            <Typography color="primary" style={{ borderBottom: '1px solid #622FEE' }} variant="text">
              Email Usage Report
            </Typography>
          </Button>
          <Select
            value={timePeriod}
            input={<Input disableUnderline />}
            displayEmpty
            renderValue={(value) =>
              selectedTimeRange.startDate && selectedTimeRange.endDate
                ? `${selectedTimeRange.startDate} - ${selectedTimeRange.endDate}`
                : PERIOD_ARR[value]
            }
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 48 * 4.5 + 8,
                  width: 250,
                },
              },
            }}
            style={{ background: '#fefefe', borderRadius: '5px', width: '220px', padding: '0px 6px' }}
          >
            {PERIOD_ARR.map((s, key) => (
              // eslint-disable-next-line react/no-array-index-key
              <MenuItem value={key} key={key} onClick={() => handleTimeRange(key)}>
                {s}
              </MenuItem>
            ))}
          </Select>
        </Grid>
      </Grid>
      <Grid style={{ background: '#fefefe' }}>
        <TabNativeContent
          tabValue={insightTabId}
          setTabValue={(id) => handleInsightTabId(id)}
          tabs={INSIGHT_TABS}
          tabWidth="18%"
        />
      </Grid>

      {insightTabId === 2 && (
        <Typography className={classes.latestVersion}>
          <span style={{ color: '#344054', marginRight: '5px' }}>Latest App Versions: </span>
          {insightData?.appConfig?.androidCurrentVersion && (
            <span style={{ marginRight: '5px' }}>{insightData?.appConfig?.androidCurrentVersion} (Android)</span>
          )}
          {insightData?.appConfig?.iosCurrentVersion && <span>{insightData?.appConfig?.iosCurrentVersion} (IOS)</span>}
        </Typography>
      )}
      {insightTabId === 4 && insightData?.leaderboard?.employees?.length > 0 && (
        <Typography style={{ padding: '5px', fontSize: '14px' }}>
          Leaderboard ({insightData?.leaderboard?.dates?.startDate} - {insightData?.leaderboard?.dates?.endDate})
        </Typography>
      )}

      <Insights insightData={insightData} tabId={insightTabId} openConfirmationPop={openConfirmationPop} />

      {isOpenCalendar && (
        <CustomDatePopup
          handleRangeSelection={handleRangeSelection}
          setAppliedFilters={setAppliedFilters}
          setIsOpenCalendar={setIsOpenCalendar}
        />
      )}
      <ConfirmationDialog
        subText="Are you sure you want to disable?"
        onClose={setIsOpenDisablePop}
        isOpen={isOpenDisablePop}
        confirmFn={handleDisable}
      />
    </Grid>
  );
}
